module.exports = __webpack_public_path__ + "img/espacios-disponibles.b728c67e.svg";